import React, { FC, useState } from "react";
import { useHistory } from "react-router";
import { useQuery } from "../../../utils";
import AutoMapping from "./AutoMapping";
import ImportDistributorInventory from "./ImportDistributorInventory";
import ImportInventoryGroupUpload from "./ImportInventoryGroupUpload";
import ImportInventoryHistory from "./ImportInventoryHistory";
import ImportInventoryUpload from "./ImportInventoryUpload";
import ImportMultiPharmacyInventoryUpload from "./ImportMultiPharmacyInventoryUpload";
import InventoryDownload from "./InventoryDownload";
import MinPriceProduct from "./MinPriceProduct";
import ProductsDownload from "./ProductsDownload";

enum ImportInventoryTabs {
    upload = "upload",
    history = "history",
    groupUpload = "groupUpload",
    autoMap = "autoMap",
    minPrice = "minPrice",
    downloadInventory = "downloadInventory",
    downloadProducts = "downloadProducts",
    uploadB2B = "uploadB2B",
    multiPharmacyUpload = "multiPharmacyUpload",
}

const ImportInventory: FC = () => {
    const query = useQuery();
    const tabId: string =
        query.get("importTabId") || ImportInventoryTabs.upload;

    const [activeTab, setActiveTab] = useState<string>(tabId);
    const history = useHistory();

    const getActiveClass = (tab: ImportInventoryTabs) => {
        return activeTab === tab ? "active" : "";
    };

    const getActiveTab = () => {
        switch (activeTab) {
            case ImportInventoryTabs.upload:
                return <ImportInventoryUpload />;
            case ImportInventoryTabs.history:
                return <ImportInventoryHistory />;
            case ImportInventoryTabs.groupUpload:
                return <ImportInventoryGroupUpload />;
            case ImportInventoryTabs.autoMap:
                return <AutoMapping></AutoMapping>;
            case ImportInventoryTabs.minPrice:
                return <MinPriceProduct></MinPriceProduct>;
            case ImportInventoryTabs.downloadInventory:
                return <InventoryDownload />;
            case ImportInventoryTabs.downloadProducts:
                return <ProductsDownload />;
            case ImportInventoryTabs.uploadB2B:
                return <ImportDistributorInventory />;
            case ImportInventoryTabs.multiPharmacyUpload:
                return <ImportMultiPharmacyInventoryUpload />;
            default:
                return <div></div>;
        }
    };

    const onSelectTab = (tab: ImportInventoryTabs) => {
        history.push(`/admin-dashboard?dashboardTabId=4&importTabId=${tab}`);
        setActiveTab(tab);
    };

    return (
        <div>
            <div className="upload-flow">
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <a
                        href="/#"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelectTab(ImportInventoryTabs.upload);
                        }}
                        className={
                            "upload-tab-title mt-3 " +
                            getActiveClass(ImportInventoryTabs.upload)
                        }
                    >
                        {getActiveClass(ImportInventoryTabs.upload) ? (
                            <img
                                alt="none"
                                src="./images/MDI-upload-active.svg"
                                title="Tải lên"
                                className="img-fluid active"
                                width="18"
                            />
                        ) : (
                            <img
                                alt="none"
                                src="./images/MDI-upload.svg"
                                title="Tải lên"
                                className="img-fluid"
                                width="18"
                            />
                        )}
                        Tải kho lẻ
                    </a>
                    <a
                        href="/#"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelectTab(ImportInventoryTabs.groupUpload);
                        }}
                        className={
                            "upload-tab-title mt-3 " +
                            getActiveClass(ImportInventoryTabs.groupUpload)
                        }
                    >
                        {getActiveClass(ImportInventoryTabs.groupUpload) ? (
                            <img
                                alt="none"
                                src="./images/MDI-upload-active.svg"
                                title="Tải lên"
                                className="img-fluid active"
                                width="18"
                            />
                        ) : (
                            <img
                                alt="none"
                                src="./images/MDI-upload.svg"
                                title="Tải lên"
                                className="img-fluid"
                                width="18"
                            />
                        )}
                        Tải kho chuỗi
                    </a>
                    <a
                        href="/#"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelectTab(ImportInventoryTabs.multiPharmacyUpload);
                        }}
                        className={
                            "upload-tab-title mt-3 " +
                            getActiveClass(ImportInventoryTabs.multiPharmacyUpload)
                        }
                    >
                        {getActiveClass(ImportInventoryTabs.multiPharmacyUpload) ? (
                            <img
                                alt="none"
                                src="./images/MDI-upload-active.svg"
                                title="Tải lên"
                                className="img-fluid active"
                                width="18"
                            />
                        ) : (
                            <img
                                alt="none"
                                src="./images/MDI-upload.svg"
                                title="Tải lên"
                                className="img-fluid"
                                width="18"
                            />
                        )}
                        Tải kho nhiều NT
                    </a>
                    <a
                        href="/#"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelectTab(ImportInventoryTabs.history);
                        }}
                        className={
                            "upload-tab-title mt-3 " +
                            getActiveClass(ImportInventoryTabs.history)
                        }
                    >
                        {getActiveClass(ImportInventoryTabs.history) ? (
                            <img
                                alt="none"
                                src="./images/MDI-history-active.svg"
                                title="Tải lên"
                                className="img-fluid active"
                                width="18"
                            />
                        ) : (
                            <img
                                alt="none"
                                src="./images/MDI-history.svg"
                                title="Tải lên"
                                className="img-fluid"
                                width="18"
                            />
                        )}
                        Lịch sử
                    </a>

                    <a
                        href="/#"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelectTab(ImportInventoryTabs.autoMap);
                        }}
                        className={
                            "upload-tab-title mt-3 " +
                            getActiveClass(ImportInventoryTabs.autoMap)
                        }
                    >
                        {getActiveClass(ImportInventoryTabs.autoMap) ? (
                            <img
                                alt="none"
                                src="./images/MDI-upload-active.svg"
                                title="Tải lên"
                                className="img-fluid active"
                                width="18"
                            />
                        ) : (
                            <img
                                alt="none"
                                src="./images/MDI-upload.svg"
                                title="Tải lên"
                                className="img-fluid"
                                width="18"
                            />
                        )}
                        Map tự động
                    </a>

                    <a
                        href="/#"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelectTab(ImportInventoryTabs.minPrice);
                        }}
                        className={
                            "upload-tab-title mt-3 " +
                            getActiveClass(ImportInventoryTabs.minPrice)
                        }
                    >
                        {getActiveClass(ImportInventoryTabs.minPrice) ? (
                            <img
                                alt="none"
                                src="./images/download-active.svg"
                                title="Tải lên"
                                className="img-fluid active"
                                width="18"
                            />
                        ) : (
                            <img
                                alt="none"
                                src="./images/download.svg"
                                title="Tải lên"
                                className="img-fluid"
                                width="18"
                            />
                        )}
                        Sp giá thấp
                    </a>
                    <a
                        href="/#"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelectTab(ImportInventoryTabs.downloadInventory);
                        }}
                        className={
                            "upload-tab-title mt-3 " +
                            getActiveClass(
                                ImportInventoryTabs.downloadInventory
                            )
                        }
                    >
                        {getActiveClass(
                            ImportInventoryTabs.downloadInventory
                        ) ? (
                            <img
                                alt="none"
                                src="./images/download-active.svg"
                                title="Tải xuống"
                                className="img-fluid active"
                                width="18"
                            />
                        ) : (
                            <img
                                alt="none"
                                src="./images/download.svg"
                                title="Tải xuống"
                                className="img-fluid"
                                width="18"
                            />
                        )}
                        Xuất kho hàng
                    </a>
                    <a
                        href="/#"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelectTab(ImportInventoryTabs.downloadProducts);
                        }}
                        className={
                            "upload-tab-title mt-3 " +
                            getActiveClass(ImportInventoryTabs.downloadProducts)
                        }
                    >
                        {getActiveClass(
                            ImportInventoryTabs.downloadProducts
                        ) ? (
                            <img
                                alt="none"
                                src="./images/download-active.svg"
                                title="Tải xuống"
                                className="img-fluid active"
                                width="18"
                            />
                        ) : (
                            <img
                                alt="none"
                                src="./images/download.svg"
                                title="Tải xuống"
                                className="img-fluid"
                                width="18"
                            />
                        )}
                        Tải sản phẩm
                    </a>

                    <a
                        href="/#"
                        onClick={(e) => {
                            e.preventDefault();
                            onSelectTab(ImportInventoryTabs.uploadB2B);
                        }}
                        className={
                            "upload-tab-title mt-3 " +
                            getActiveClass(ImportInventoryTabs.uploadB2B)
                        }
                    >
                        {getActiveClass(ImportInventoryTabs.uploadB2B) ? (
                            <img
                                alt="none"
                                src="./images/MDI-upload-active.svg"
                                title="Tải lên"
                                className="img-fluid active"
                                width="18"
                            />
                        ) : (
                            <img
                                alt="none"
                                src="./images/MDI-upload.svg"
                                title="Tải lên"
                                className="img-fluid"
                                width="18"
                            />
                        )}
                        Tải kho B2B
                    </a>
                </div>

                {getActiveTab()}
            </div>
        </div>
    );
};

export default ImportInventory;
